var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebinar28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 3C3.22386 3 3 3.22386 3 3.5V19.5C3 19.7761 3.22386 20 3.5 20H14V23H8.5C8.22386 23 8 23.2239 8 23.5C8 23.7761 8.22386 24 8.5 24H14.5H20.5C20.7761 24 21 23.7761 21 23.5C21 23.2239 20.7761 23 20.5 23H15V20H25.5C25.7761 20 26 19.7761 26 19.5V3.5C26 3.22386 25.7761 3 25.5 3H3.5ZM14.5 19H25V4H4V19H14.5Z",
  fill: "currentColor"
})));
export default SvgWebinar28;